import { render } from "./DLViewer.vue?vue&type=template&id=6ef485ff&scoped=true"
import script from "./DLViewer.vue?vue&type=script&lang=js"
export * from "./DLViewer.vue?vue&type=script&lang=js"

import "./DLViewer.vue?vue&type=style&index=0&id=6ef485ff&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dl-viewer/dl-viewer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef485ff"]])

export default __exports__